export interface IdlingSettings {
  fuelPrice: number;
  currency: string;
  unit: 'L' | 'gal';
  burnRateL: number;
}

export interface IdlingVehicleRaw {
  name: string;
  group: string;
  groupsLabel: string;
  groupRollups: string[];
  eventCount: number;
  idleHrs: number;
  longestIdleHrs: number;
  pctDrive: number;
}

export interface IdlingVehicleDecorated extends IdlingVehicleRaw {
  fuelVol: number;
  cost: number;
}

export const L_PER_GAL    = 3.785411784;
export const BURN_RATES_L: Record<string, number> = { light: 1.5, medium: 3.5, heavy: 6.0 };
export const CURR_SYMBOLS: Record<string, string>  = {
  USD: '$', EUR: '€', MXN: '$', GBP: '£', CAD: '$', AUD: '$', BRL: 'R$',
};
